import React, { useState, useRef, useEffect } from 'react';
import './EditMessage.css';

function EditMessage({ message, onSave, onCancel }) {
  const [editedText, setEditedText] = useState(message.text);
  const inputRef = useRef(null);
  
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      // Move cursor to end instead of selecting all
      inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
    }
  }, []);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (editedText.trim() && editedText !== message.text) {
      onSave(message, editedText);
    } else {
      onCancel();
    }
  };
  
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onCancel();
    }
  };
  
  return (
    <form className="edit-message-form" onSubmit={handleSubmit}>
      <input
        ref={inputRef}
        type="text"
        value={editedText}
        onChange={(e) => setEditedText(e.target.value)}
        onKeyDown={handleKeyDown}
        className="edit-message-input"
        placeholder="Edit your message..."
      />
      <div className="edit-message-actions">
        <button type="button" onClick={onCancel} className="edit-cancel-btn">
          Cancel
        </button>
        <button type="submit" className="edit-save-btn">
          Save
        </button>
      </div>
    </form>
  );
}

export default EditMessage;